import fetch from '@/utils/fetch';
// import {api_url} from "../popular/index"
const api_url = process.env.VUE_APP_API;

export const loginApi = data => fetch({//手机号密码登录
  url: `${api_url}/login?mobile=${data.mobile}&password=${data.password}`,
  method: 'post',
  data ,
});


export const verificationApi = data => fetch({//手机验证码登录
  url: `${api_url}/login/code?code=${data.password1}&mobile=${data.mobile1}&version=${data.version}`,
  method: 'post',
  data ,
});

export const logPage = data => fetch({//登录log分页显示
  url: `${api_url}/user/log/${data.page}/${data.pageCount}`,
});

export const getAdmin = (data) => {//获取管理员列表
  let url = '';
  if(data.roleId){
    url= `${api_url}/admin?roleId=${data.roleId}`
  }else{
    url= `${api_url}/admin`
  }
  return fetch({
  url
  })
};
export const getRole = () => fetch({//获取角色列表
  url: `${api_url}/role`,
});

export const getLimitList = (data) => {//创建角色获取权限列表
  let url = '';
  if(data.roleId){
    url= `${api_url}/role/menu?roleId=${data.roleId}`
  }else{
    url= `${api_url}/role/menu`
  }
  return fetch({
  url
  })
};
export const addRole = data => fetch({//添加角色
  url: `${api_url}/role`,
  method: 'post',
  data ,
});
export const addAdmin = data => fetch({//添加管理员
  url: `${api_url}/admin`,
  method: 'post',
  data ,
});
export const deleteRole = data => fetch({//删除角色
  url: `${api_url}/role/${data.roleId}`,
  method: 'delete',
  data ,
});
export const deleteAdmin = data => fetch({//删除管理员
  url: `${api_url}/admin/${data.userId}`,
  method: 'delete',
  data ,
});
export const getUser = (data) => fetch({//管理员详情
  url: `${api_url}/admin/${data.userId}`,
});
export const getLimit = (data) => fetch({//查看角色对应权限
  url: `${api_url}/role/${data.roleId}`,
});
export const getList = (data) => fetch({//查看左侧菜单
  url: `${api_url}/user/role/menu/${data.roleId}/${data.parentId}`,
});
export const setAdmin = data => fetch({//修改管理员
  url: `${api_url}/admin`,
  method: 'put',
  data ,
});
export const setRole = data => fetch({//修改角色
  url: `${api_url}/role`,
  method: 'put',
  data ,
});
export const getMobile = (data) => fetch({//根据用户手机号获取用户名
  url: `${api_url}/user/name/${data}`,
});
export const getRoleDetail = (data) => fetch({//角色详情
  url: `${api_url}/role/info/${data.roleId}`,
});

export const getCertificationList = (data) => fetch({
  url:`${api_url}/user/kyc/record/${data.status}/${data.page}/${data.size}`,
})
export const getSearchCertificationList = (data) => fetch({
  url:`${api_url}/rpc/user/kyc/record/search/${data.status}/${data.page}/${data.size}?key=${data.key}`,
})

export const getCardImg = (data) => fetch({
  url:`${api_url}/user/kyc/record/pic`,
  method: 'post',
  data,
})

export const setStatus = (data) => fetch({
  url:`${api_url}/user/kyc/status`,
  method: 'post',
  data,
})

export const getFeedBackList = (data) => fetch({
  url:`${api_url}/feedback/list`,
  method: 'post',
  data
})

export const getFeedBackDetail = (id) => fetch({
  url:`${api_url}/feedback/detail/${id}`,
})

export const replyFeedBack = (data) => fetch({
  url:`${api_url}/feedback/reply`,
  method: 'post',
  data
})

